import { Component, OnInit, Input, Inject,ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';
import { DEVICE_INFO, DeviceInfo, APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: "item-list",
    templateUrl: "./item-list.template.html",
    styleUrls: ['./item-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ItemList implements OnInit {
    @Input() list: any;
    //@Input() content$: any;
    @Input() config: MediaCellConfig;
    @Input() paginate: Boolean;
    @Input() reveal:Boolean = true;
    @Input() showRemove: Boolean = false;
    @Input() promptRemove: false;
    @Input() promptItem: string;
    
    settings: any = {
        size: "md",
        showHeader: true,
        showCopy: true,
        showDetail: true,
        showCount: true,
        imageType: null,
        pageSize: 7,
        invert: false
    }
    private deviceType : DeviceInfo;
    private currentPage: number;    
    private totalPages: number = 1;
    private subscriptions: Array<any> = [];
    private style: string;
    public isPhone : boolean = false;

    constructor(
        private effects: CoreEffects,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef,
        @Inject(DEVICE_INFO) device: DeviceInfo,
    ) { 

        this.isPhone = device.isPhone;
    }

    ngOnInit() {
        Object.assign(this.settings, this.config);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.list && changes.list.currentValue !== changes.list.previousValue) {
            if (this.paginate && this.list.data) {
                this.currentPage = this.reveal ? 1 : 0;
                this.totalPages = this.paginate ? Math.ceil(this.list.data.length / (this.settings.pageSize - 1)) : 1;
            }
        }
    }

    getPagedData(item): Array<any> {
        if (this.paginate) {
            let startIndex = 0, rangeIndex = 1;

            if (this.reveal) {
                rangeIndex = this.currentPage * this.settings.pageSize           
            }
            else {
                startIndex = this.currentPage * (this.settings.pageSize -1);
                rangeIndex = startIndex + (this.settings.pageSize - 1)
            }
            return item && item.data && item.data.slice(startIndex, rangeIndex) || []
        } else {
            return item.data;
        }
    }

    revealNextPage(e) {
        if (this.currentPage < this.totalPages) {
            this.currentPage += 1;
        }
    }

    movePageBy(page:number){
        let targetPage = this.currentPage + page;
        if (targetPage >= 0 && targetPage < this.totalPages) {
            this.currentPage = targetPage;
        }        
    }

    removeFavorite(meta){

        if (this.showRemove){
            const favoriteObj : any = {
                add : false,
                item : {
                    meta: meta
                }
            }
            this.effects.addOrRemoveFavorite(favoriteObj);
            this.list.data = this.list.data.filter(item => item.meta.unique_id != meta.unique_id);
            this.cd.detectChanges();
            //console.log("successful removal");
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/item-list/item-list.component.ts